export enum Routes {
  HOME = '/home',
  DASHBOARD = '/dashboard',
  ORG_MANAGER = '/organizationManager',
  NET_ZERO = '/netZero',
  ESG = '/ESG',
  COMMS = '/comms',
  SETTING = '/setting',
  OCR = '/OCR',
  CONFIGURATOR = '/configurator',
  STRATEGY = '/strategy',
  ACTIVITY_LOG = '/activityLog',
  AI_DOCUMENT_MANAGER = '/aiDocumentManager',
  REPORT_STUDIO = '/reportStudio',
  LOGOUT = 'logout',
  PRICING_DETAILS = '/pricingDetails',
  PLATFORM_EDUCATION = '/learningHub',
  DATA_LINEAGE = '/dataLineage'
}

export enum subRoutes {
  orgManager = '/orgManager',
  facility = '/facilityAndOwnerShip',
  supplierInfo = '/supplierInfo',
  infraProfile = '/infraProfile',
  assetManagement = '/assetManagement',
  investments = '/investments',
  unitPreference = '/unitpreferences',
  userManager = '/userManager',
  products = '/product',
  setup = '/setup',
  addUser = '/addUser',
  updateUser = '/updateUser',
  updateRole = '/updateRole',
  metrics = '/metrics',
  stakeholderTracking = '/stakeholderTracking',
  nzmGeneral = '/generalized',
  nzmUtilities = '/utilities',
  nzmSC = '/supplyChain',
  nzmTravel = '/travel',
  nzmCG = '/capitalGoods',
  nzmOA = '/otherActivities',
  nzmAM = '/asset',
  nzmProduct = '/products',
  addRole = '/addRole',
  roleManager = '/roleManager',
  Organisation_Facility = '/org',
  Value_chain_management = '/valueChainMng',
  org_and_process_flow = '/orgFlow',
  data_management = '/dataManagement',
  display_OCR = '/display',
  OCR = '/OCR',
  user_management = '/userManagement',
  process_flow = '/processFlow',
  peer_bechmarking = '/peerBenchmarking',
  gap_analysis = '/gapAnalysis',
  framework = '/frameworks'
}

export const allRoutes = {
  HOME: {
    HOME: `${Routes.HOME}`
  },
  dashboard: {
    metrics: `${Routes.DASHBOARD}${subRoutes.metrics}`,
    stakeholderTracking: `${Routes.DASHBOARD}${subRoutes.stakeholderTracking}`
  },
  Configurator: {
    org_facility: `${Routes.CONFIGURATOR}${subRoutes.Organisation_Facility}`,
    valueChainMng: `${Routes.CONFIGURATOR}${subRoutes.Value_chain_management}`,
    org_and_process_flow: `${Routes.CONFIGURATOR}${subRoutes.org_and_process_flow}`,
    process_flow: `${Routes.CONFIGURATOR}${subRoutes.process_flow}`,
    data_management: `${Routes.CONFIGURATOR}${subRoutes.data_management}`,
    user_management: `${Routes.CONFIGURATOR}${subRoutes.user_management}`,
    OCRMain: `${Routes.CONFIGURATOR}${subRoutes.OCR}`,
    OCRdisplay: `${Routes.CONFIGURATOR}${subRoutes.OCR}${subRoutes.display_OCR}`,
    userManager: `${Routes.CONFIGURATOR}${subRoutes.userManager}`,
    addUser: `${Routes.CONFIGURATOR}${subRoutes.userManager}${subRoutes.addUser}`,
    updateUser: `${Routes.CONFIGURATOR}${subRoutes.userManager}${subRoutes.updateUser}`,
    roleManager: `${Routes.CONFIGURATOR}${subRoutes.userManager}${subRoutes.roleManager}`,
    addRole: `${Routes.CONFIGURATOR}${subRoutes.userManager}${subRoutes.roleManager}${subRoutes.addRole}`,
    updateRole: `${Routes.CONFIGURATOR}${subRoutes.userManager}${subRoutes.roleManager}${subRoutes.updateRole}`
  },
  OM: {
    orgManager: `${Routes.ORG_MANAGER}${subRoutes.orgManager}`,
    facility: `${Routes.ORG_MANAGER}${subRoutes.facility}`,
    supplier: `${Routes.ORG_MANAGER}${subRoutes.supplierInfo}`,
    infraProfile: `${Routes.ORG_MANAGER}${subRoutes.infraProfile}`,
    assetManagement: `${Routes.ORG_MANAGER}${subRoutes.assetManagement}`,
    investments: `${Routes.ORG_MANAGER}${subRoutes.investments}`,
    products: `${Routes.ORG_MANAGER}${subRoutes.products}`
  },
  ESG: {
    FRAMEWORK: `${Routes.ESG}${subRoutes.framework}`,
    PEER_BENCHMARKING: `${Routes.ESG}${subRoutes.peer_bechmarking}`,
    GAP_ANALYSIS: `${Routes.ESG}${subRoutes.gap_analysis}`
  },
  OCR: {
    OCRMain: `${Routes.OCR}/main`,
    OCRdisplay: `${Routes.OCR}/display`
  },
  AI_DOCUMENT_MANAGER: {
    DOCUMENT_MANAGER: `${Routes.AI_DOCUMENT_MANAGER}`
  },
  NZM: {
    generalized: `${Routes.NET_ZERO}${subRoutes.nzmGeneral}`,
    utilities: `${Routes.NET_ZERO}${subRoutes.nzmUtilities}`,
    supplyChain: `${Routes.NET_ZERO}${subRoutes.nzmSC}`,
    travel: `${Routes.NET_ZERO}${subRoutes.nzmTravel}`,
    capitalGoods: `${Routes.NET_ZERO}${subRoutes.nzmCG}`,
    otherActivities: `${Routes.NET_ZERO}${subRoutes.nzmOA}`,
    asset: `${Routes.NET_ZERO}${subRoutes.nzmAM}`,
    products: `${Routes.NET_ZERO}${subRoutes.nzmProduct}`
  },
  DATA_LINEAGE: {
    dataLineage: `${Routes.DATA_LINEAGE}`
  },
  setting: {
    unitPreference: `${Routes.SETTING}${subRoutes.unitPreference}`,
    userManager: `${Routes.SETTING}${subRoutes.userManager}`,
    setup: `${Routes.SETTING}${subRoutes.setup}`,
    addUser: `${Routes.SETTING}${subRoutes.userManager}${subRoutes.addUser}`,
    updateUser: `${Routes.SETTING}${subRoutes.userManager}${subRoutes.updateUser}`,
    roleManager: `${Routes.SETTING}${subRoutes.userManager}${subRoutes.roleManager}`,
    addRole: `${Routes.SETTING}${subRoutes.userManager}${subRoutes.roleManager}${subRoutes.addRole}`,
    updateRole: `${Routes.SETTING}${subRoutes.userManager}${subRoutes.roleManager}${subRoutes.updateRole}`
  },
  comms: {
    comms: `${Routes.COMMS}`
  }
};
